import auflaufIcon from '../assets/category-icons/auflauf.svg?raw';
import besteckIcon from '../assets/category-icons/besteck.svg?raw';
import burgerIcon from '../assets/category-icons/burger.svg?raw';
import drinksIcon from '../assets/category-icons/drinks.svg?raw';
import fladenbrotIcon from '../assets/category-icons/fladenbrot.svg?raw';
import grillIcon from '../assets/category-icons/grill.svg?raw';
import friesIcon from '../assets/category-icons/pommes.svg?raw';
import iceCreamIcon from '../assets/category-icons/eisbecher.svg?raw';
import kebabIcon from '../assets/category-icons/kebap.svg?raw';
import pastaIcon from '../assets/category-icons/pasta.svg?raw';
import pfannengerichteIcon from '../assets/category-icons/pfannengerichte.svg?raw';
import pizzaIcon from '../assets/category-icons/pizza.svg?raw';
import saladIcon from '../assets/category-icons/salat.svg?raw';
import sauceIcon from '../assets/category-icons/sauce.svg?raw';
import softdrinksIcon from '../assets/category-icons/softdrinks.svg?raw';
import taschenpizzaIcon from '../assets/category-icons/taschenpizza.svg?raw';
import fishIcon from '../assets/category-icons/fisch.svg?raw';
import chickenIcon from '../assets/category-icons/haehnchen.svg?raw';
import soupIcon from '../assets/category-icons/suppe.svg?raw';
import dessertIcon from '../assets/category-icons/dessert.svg?raw';
import breakfastIcon from '../assets/category-icons/fruehstueck.svg?raw';
import wrapIcon from '../assets/category-icons/wrap.svg?raw';
import spicyIcon from '../assets/category-icons/scharf.svg?raw';
import veganIcon from '../assets/category-icons/vegan.svg?raw';
import coffeeIcon from '../assets/category-icons/kaffee.svg?raw';
import snacksIcon from '../assets/category-icons/snacks.svg?raw';
import pizzaKleinIcon from '../assets/category-icons/pizza_klein.svg?raw';
import steakIcon from '../assets/category-icons/steak.svg?raw';
import broetchenIcon from '../assets/category-icons/broetchen.svg?raw';
import pizzaSliceIcon from '../assets/category-icons/pizza_slice.svg?raw';
import { parseCategoryIconSvgAsset } from '../utils/parseCategoryIconSvgAsset';
/** Custom SVG assets (inlined with currentColor) */
export const CATEGORY_ICON_ASSETS = {
    utensils: parseCategoryIconSvgAsset(besteckIcon),
    kebab: parseCategoryIconSvgAsset(kebabIcon),
    pizza: parseCategoryIconSvgAsset(pizzaIcon),
    pasta: parseCategoryIconSvgAsset(pastaIcon),
    pfannengerichte: parseCategoryIconSvgAsset(pfannengerichteIcon),
    salad: parseCategoryIconSvgAsset(saladIcon),
    drinks: parseCategoryIconSvgAsset(drinksIcon),
    'ice-cream': parseCategoryIconSvgAsset(iceCreamIcon),
    fries: parseCategoryIconSvgAsset(friesIcon),
    burger: parseCategoryIconSvgAsset(burgerIcon),
    fladenbrot: parseCategoryIconSvgAsset(fladenbrotIcon),
    grill: parseCategoryIconSvgAsset(grillIcon),
    sauce: parseCategoryIconSvgAsset(sauceIcon),
    taschenpizza: parseCategoryIconSvgAsset(taschenpizzaIcon),
    softdrinks: parseCategoryIconSvgAsset(softdrinksIcon),
    auflauf: parseCategoryIconSvgAsset(auflaufIcon),
    fish: parseCategoryIconSvgAsset(fishIcon),
    chicken: parseCategoryIconSvgAsset(chickenIcon),
    soup: parseCategoryIconSvgAsset(soupIcon),
    dessert: parseCategoryIconSvgAsset(dessertIcon),
    breakfast: parseCategoryIconSvgAsset(breakfastIcon),
    wrap: parseCategoryIconSvgAsset(wrapIcon),
    spicy: parseCategoryIconSvgAsset(spicyIcon),
    vegan: parseCategoryIconSvgAsset(veganIcon),
    coffee: parseCategoryIconSvgAsset(coffeeIcon),
    snacks: parseCategoryIconSvgAsset(snacksIcon),
    'pizza-klein': parseCategoryIconSvgAsset(pizzaKleinIcon),
    steak: parseCategoryIconSvgAsset(steakIcon),
    broetchen: parseCategoryIconSvgAsset(broetchenIcon),
    'pizza-slice': parseCategoryIconSvgAsset(pizzaSliceIcon),
};
/** Monochrome SVG paths (viewBox 0 0 24 24, fill via currentColor) */
export const CATEGORY_ICON_SVGS = {
    kebab: '<ellipse cx="12" cy="19" rx="5" ry="2"/><path d="M9 3h6l-1 14H10L9 3z"/><path d="M10 7h4"/>',
    pizza: '<path d="M12 3L3 19h18L12 3z"/><circle cx="9" cy="14" r="1"/><circle cx="14" cy="12" r="1"/><circle cx="12" cy="16" r="1"/>',
    pasta: '<path d="M4 12c2-4 6-6 8-6s6 2 8 6"/><path d="M6 14c1.5 3 4 5 6 5s4.5-2 6-5"/><path d="M8 16c1 2 2.5 3 4 3s3-1 4-3"/>',
    salad: '<path d="M12 21c-5 0-8-3-8-7 0-2 1-4 3-5 1-1 3-2 5-2s4 1 5 2c2 1 3 3 3 5 0 4-3 7-8 7z"/><path d="M8 10c1-2 2-3 4-3s3 1 4 3"/>',
    chicken: '<path d="M8 12c-2-3-1-7 2-8 2-1 4 1 4 4 0 2-1 4-2 5l3 3-2 2-3-2c-1 2-3 3-5 3-2 0-3-2-2-4z"/><circle cx="14" cy="7" r="1"/>',
    fish: '<path d="M3 12c3-4 7-6 12-6 2 0 4 1 6 2l2-2v8l-2-2c-2 1-4 2-6 2-5 0-9-2-12-6z"/><circle cx="14" cy="11" r="1"/>',
    drinks: '<path d="M8 3h8l-1 9a4 4 0 0 1-8 0L8 3z"/><path d="M10 16v3h4v-3"/><path d="M9 21h6"/>',
    coffee: '<path d="M6 8h10v6a4 4 0 0 1-8 0V8z"/><path d="M16 10h2a2 2 0 0 1 0 4h-2"/><path d="M8 4h6"/>',
    dessert: '<path d="M6 14c0-4 2.5-7 6-7s6 3 6 7v2H6v-2z"/><path d="M8 18h8"/><circle cx="10" cy="11" r="1"/><circle cx="14" cy="11" r="1"/>',
    'ice-cream': '<path d="M8 14l4 8 4-8H8z"/><path d="M9 6a3 3 0 0 1 6 0v4a3 3 0 0 1-6 0V6z"/>',
    fries: '<path d="M7 4l2 16M11 3l1 17M15 4l-1 16M19 6l-3 14"/><path d="M5 20h14"/>',
    wrap: '<ellipse cx="12" cy="12" rx="9" ry="5"/><path d="M5 12c2 2 4 3 7 3s5-1 7-3"/>',
    soup: '<path d="M4 14c0 4 3.5 6 8 6s8-2 8-6"/><path d="M6 10c0-3 2.5-5 6-5s6 2 6 5"/><path d="M4 14h16"/>',
    breakfast: '<circle cx="12" cy="13" r="5"/><path d="M12 8V3M9 5l2 2M15 5l-2 2"/>',
    vegan: '<path d="M12 21C8 17 5 13 5 9a7 7 0 0 1 14 0c0 4-3 8-7 12z"/><path d="M12 8v5M10 10h4"/>',
    spicy: '<path d="M12 2c2 4 1 6-1 8 2-1 3 1 3 4 0 3-2 5-5 5s-5-2-5-5c0-3 1-5 3-4-2-2-3-4-1-8z"/>',
};
export const CATEGORY_ICONS = [
    { id: 'utensils', label: 'Besteck', tags: ['allgemein', 'speise'] },
    { id: 'kebab', label: 'Kebab', tags: ['döner', 'fleisch', 'türkisch'] },
    { id: 'pizza', label: 'Pizza', tags: ['italienisch', 'teig'] },
    { id: 'burger', label: 'Burger', tags: ['fast food', 'fleisch'] },
    { id: 'fladenbrot', label: 'Fladenbrot', tags: ['brot', 'lahmacun', 'türkisch'] },
    { id: 'grill', label: 'Grill', tags: ['grillen', 'bbq', 'fleisch', 'steak'] },
    { id: 'sauce', label: 'Soße', tags: ['sauce', 'dip', 'ketchup'] },
    { id: 'pasta', label: 'Pasta', tags: ['nudeln', 'italienisch'] },
    { id: 'pfannengerichte', label: 'Pfannengerichte', tags: ['pfanne', 'gebraten', 'wok', 'warm'] },
    { id: 'salad', label: 'Salat', tags: ['gesund', 'vegetarisch'] },
    { id: 'chicken', label: 'Hähnchen', tags: ['fleisch', 'geflügel'] },
    { id: 'fish', label: 'Fisch', tags: ['meer', 'fisch'] },
    { id: 'drinks', label: 'Getränke', tags: ['trinken', 'becher'] },
    { id: 'coffee', label: 'Kaffee', tags: ['heiß', 'getränk'] },
    { id: 'dessert', label: 'Dessert', tags: ['süß', 'kuchen'] },
    { id: 'ice-cream', label: 'Eis', tags: ['süß', 'kalt'] },
    { id: 'fries', label: 'Pommes', tags: ['beilage', 'fast food'] },
    { id: 'wrap', label: 'Wrap', tags: ['tasche', 'roll'] },
    { id: 'taschenpizza', label: 'Taschenpizza', tags: ['calzone', 'teig', 'pizza'] },
    { id: 'softdrinks', label: 'Softdrinks', tags: ['cola', 'limo', 'getränk'] },
    { id: 'auflauf', label: 'Auflauf', tags: ['ofen', 'warm', 'auflauf'] },
    { id: 'soup', label: 'Suppe', tags: ['warm', 'schüssel'] },
    { id: 'breakfast', label: 'Frühstück', tags: ['ei', 'morgen'] },
    { id: 'vegan', label: 'Vegan', tags: ['pflanze', 'blatt'] },
    { id: 'spicy', label: 'Scharf', tags: ['chili', 'scharf'] },
    { id: 'snacks', label: 'Snacks', tags: ['snack', 'fingerfood', 'kleinigkeit'] },
    { id: 'pizza-klein', label: 'Pizza (klein)', tags: ['pizza', 'klein', 'single', 'personal'] },
    { id: 'steak', label: 'Steak', tags: ['fleisch', 'rind', 'grill'] },
    { id: 'broetchen', label: 'Brötchen', tags: ['brot', 'backwaren', 'frühstück'] },
    { id: 'pizza-slice', label: 'Pizza-Stück', tags: ['pizza', 'stück', 'slice', 'snack'] },
];
export const DEFAULT_CATEGORY_ICON_ID = 'utensils';
const SLUG_ICON_FALLBACKS = {
    hauptgerichte: 'burger',
    burgers: 'burger',
    'smash-burger': 'burger',
    chicken: 'chicken',
    'chicken-spezialitäten': 'chicken',
    beilagen: 'fries',
    sides: 'fries',
    'beilagen-&-sides': 'fries',
    pommes: 'fries',
    salate: 'salad',
    bowls: 'salad',
    'salate-&-bowls': 'salad',
    getränke: 'drinks',
    getraenke: 'drinks',
    drinks: 'drinks',
    softdrinks: 'softdrinks',
    'alkoholische-getränke': 'drinks',
    alcohol: 'drinks',
    vorspeisen: 'soup',
    desserts: 'dessert',
    pizza: 'pizza',
    pizzaklassik: 'pizza',
    'pizza-a-la-mavi': 'pizza',
    'pizzavariation-la-mavi': 'pizza',
    familienpizza: 'pizza',
    taschenpizza: 'taschenpizza',
    pfannengerichte: 'pfannengerichte',
    pfanne: 'pfannengerichte',
    'pfannen-gerichte': 'pfannengerichte',
    pan: 'pfannengerichte',
    grill: 'grill',
    grillgerichte: 'grill',
    gegrilltes: 'grill',
    bbq: 'grill',
    steak: 'steak',
    steaks: 'steak',
    coffee: 'coffee',
    kaffee: 'coffee',
    'kaffee-&-kuchen': 'coffee',
    snacks: 'snacks',
    snack: 'snacks',
    fingerfood: 'snacks',
    'pizza-klein': 'pizza-klein',
    'kleine-pizza': 'pizza-klein',
    'mini-pizza': 'pizza-klein',
    'pizza-slice': 'pizza-slice',
    pizzastueck: 'pizza-slice',
    'pizza-stueck': 'pizza-slice',
    broetchen: 'broetchen',
    brötchen: 'broetchen',
    kebab: 'kebab',
    kebapgerichte: 'kebab',
    aufläufe: 'auflauf',
    auflufe: 'auflauf',
    auflauf: 'auflauf',
    getrnke: 'drinks',
    saucen: 'sauce',
    sauce: 'sauce',
    fladenbrot: 'fladenbrot',
};
export function getCategoryIconFallbackForSlug(slugOrId) {
    const key = (slugOrId || '').trim().toLowerCase();
    if (!key)
        return DEFAULT_CATEGORY_ICON_ID;
    return SLUG_ICON_FALLBACKS[key] || DEFAULT_CATEGORY_ICON_ID;
}
const LEGACY_DEFAULT_ICONS = new Set(['utensils', 'fas fa-utensils']);
/** Portal-Altbestand: generisches Besteck → slug-basierter Fallback, wenn kein echtes Custom-Icon gesetzt ist. */
export function resolveCategoryIconFromApi(icon, slugOrId) {
    const value = (icon || '').trim();
    if (!value || LEGACY_DEFAULT_ICONS.has(value)) {
        return getCategoryIconFallbackForSlug(slugOrId);
    }
    return resolveCategoryIconId(value);
}
const FA_ICON_MAP = {
    'fas fa-utensils': 'utensils',
    'fas fa-hamburger': 'burger',
    'fas fa-pizza-slice': 'pizza',
    'fas fa-drumstick-bite': 'chicken',
    'fas fa-fish': 'fish',
    'fas fa-coffee': 'coffee',
    'fas fa-wine-glass': 'drinks',
    'fas fa-ice-cream': 'ice-cream',
    'fas fa-leaf': 'vegan',
    'fas fa-pepper-hot': 'spicy',
    'fas fa-bread-slice': 'breakfast',
    'fas fa-bowl-food': 'soup',
};
export function resolveCategoryIconId(icon) {
    const value = (icon || '').trim();
    if (!value)
        return DEFAULT_CATEGORY_ICON_ID;
    if (FA_ICON_MAP[value])
        return FA_ICON_MAP[value];
    if (CATEGORY_ICON_ASSETS[value])
        return value;
    if (CATEGORY_ICON_SVGS[value])
        return value;
    if (/\bfa-/.test(value))
        return DEFAULT_CATEGORY_ICON_ID;
    return value;
}
export function isLegacyFontAwesomeIcon(icon) {
    const value = (icon || '').trim();
    return /\bfa[srb]?\s+fa-/.test(value) && !FA_ICON_MAP[value];
}
export function getCategoryIconSvg(icon) {
    const id = resolveCategoryIconId(icon);
    if (CATEGORY_ICON_ASSETS[id])
        return null;
    return CATEGORY_ICON_SVGS[id] || CATEGORY_ICON_SVGS[DEFAULT_CATEGORY_ICON_ID];
}
export function getCategoryIconAsset(icon) {
    const id = resolveCategoryIconId(icon);
    return CATEGORY_ICON_ASSETS[id] || null;
}
